import {
  Card,
  ChartEmptyState,
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const chartEmptyStateWrapper: CSSProperties = {
  display: 'grid',
  height: '80px'
}

const RunSelectedNoTestConfigStep = () =>
  <div className='grid'>
    <div style={chartEmptyStateWrapper}>
      <Card>
        <ChartEmptyState
          title='No results'
        >
          <Paragraph>
            <Color variant='theme-filter-icon'>
              Please try adjusting your filter settings.
            </Color>
          </Paragraph>
        </ChartEmptyState>
      </Card>
    </div>
  </div>

export default RunSelectedNoTestConfigStep
